// extracted by mini-css-extract-plugin
export default {"card":"label-editor_card__bCv6b"};